import React from 'react';
import { MdDescription } from 'react-icons/md';
import type { MenuSuggestion } from './types';

interface SuggestionCardProps {
  suggestion: MenuSuggestion;
}

const SuggestionCard: React.FC<SuggestionCardProps> = ({ suggestion }) => {
  return (
    <div 
      className="rounded-xl p-4"
      style={{
        boxShadow: 'rgba(0, 0, 0, 0.1) 0px 0px 14px 0px',
        background: '#212121',
        border: '1px solid rgba(224, 224, 224, 0.13)'
      }}
    >
      {/* Header */}
      <div className="flex items-start justify-between mb-2">
        <div className="flex-1">
          <div className="flex items-center gap-3 mb-4">
            <span 
              className="px-2 py-1 rounded-full text-[10px] font-light text-gray-200 flex items-center gap-1"
              style={{
                // backgroundColor: 'rgba(238, 68, 37, 0.1)',
                border: '1px solid #616161'
              }}
            >
              {/* <MdDescription size={14} /> */}
              {suggestion.suggestion_type}
            </span>
          </div>
          <h3 className="text-md font-medium text-white mb-">
            {suggestion.suggestion_name}
          </h3>
        </div>
        <button 
          className="px-3 py-1 cursor-pointer rounded-lg text-[10px] font-medium text-white transition-colors"
          style={{
            backgroundColor: '#EE4423',
            border: '1px solid #EE4423'
          }}
          onMouseOver={(e) => e.currentTarget.style.backgroundColor = '#EE4423'}
          onMouseOut={(e) => e.currentTarget.style.backgroundColor = '#EE4423'}
        >
          + Add to menu
        </button>
      </div>

      {/* Price and Category */}
      <div className="flex items-center gap-4 mb-4">
        <div>
          <span className="text-gray-400 text-[10px] font-light">Suggested Price: </span>
          <span className="text-brand-primary text-sm font-medium">
            ${suggestion.suggested_price.toFixed(2)}
          </span>
        </div>
        <div>
          <span className="text-gray-400 text-[10px] font-light">Category: </span>
          <span className="text-brand-primary text-sm font-medium">{suggestion.category}</span>
        </div>
      </div>

      {/* Description */}
      <p className="text-gray-300 text-xs leading-relaxed mb-4">
        {suggestion.description}
      </p>

      {/* Strategic Rationale */}
      <div 
        className="rounded-lg p-4"
        style={{
          backgroundColor: '#000',
          border: '1px solid rgba(224, 224, 224, 0.1)'
        }}
      >
        <div className="flex items-center gap-2 mb-2">
          <h4 className="text-xs font-medium text-white uppercase tracking-wide">
            Strategic Rationale
          </h4>
        </div>
        <p className="text-gray-200 text-[12px] leading-relaxed font-light">
          {suggestion.rationale}
        </p>
      </div>
    </div>
  );
};

export default SuggestionCard;
